import { COLORS } from 'helpers/globals'

export default {
  a: {
    color: COLORS.primary,
    textDecoration: 'none',
    cursor: 'pointer',
    '&:hover': {
      color: COLORS.secondary
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/globalStyles/link.js